import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Lock, Mail, Loader2 } from "lucide-react";

const AdminLogin = () => {
  const { login, user, loading } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [submitting, setSubmitting] = useState(false);

  if (loading) return null;
  if (user) return <Navigate to="/admin" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr("");
    setSubmitting(true);
    try {
      await login(email.trim(), password);
      nav("/admin", { replace: true });
    } catch (e) {
      const d = e?.response?.data?.detail;
      setErr(typeof d === "string" ? d : "Échec de la connexion");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-black flex items-center justify-center p-6">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-2xl overflow-hidden" data-testid="admin-login-card">
        <div className="bg-gradient-to-r from-yellow-500 to-yellow-400 p-8 text-center">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-white/20 rounded-2xl mb-3">
            <Lock className="text-white" size={28} />
          </div>
          <h1 className="text-2xl font-bold text-white">Administration SOGI</h1>
          <p className="text-white/90 text-sm mt-1">Connectez-vous pour gérer vos projets</p>
        </div>

        <form onSubmit={onSubmit} className="p-8 space-y-5">
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-2">Email</label>
            <div className="relative">
              <Mail className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full pl-10 pr-4 py-3 border-2 border-gray-200 rounded-xl focus:border-yellow-500 focus:outline-none transition-colors"
                placeholder="admin@sogi.sn"
                data-testid="admin-login-email"
              />
            </div>
          </div>
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-2">Mot de passe</label>
            <div className="relative">
              <Lock className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
              <input
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full pl-10 pr-4 py-3 border-2 border-gray-200 rounded-xl focus:border-yellow-500 focus:outline-none transition-colors"
                placeholder="••••••••"
                data-testid="admin-login-password"
              />
            </div>
          </div>
          {err && (
            <div className="bg-red-50 border border-red-200 text-red-700 text-sm px-4 py-3 rounded-xl" data-testid="admin-login-error">
              {err}
            </div>
          )}
          <button
            type="submit"
            disabled={submitting}
            className="w-full bg-gradient-to-r from-yellow-500 to-yellow-400 text-white font-bold py-3 rounded-xl hover:shadow-lg transition-all disabled:opacity-60 flex items-center justify-center gap-2"
            data-testid="admin-login-submit"
          >
            {submitting && <Loader2 className="animate-spin" size={18} />}
            Se connecter
          </button>
          <div className="text-center">
            <a href="/" className="text-sm text-gray-500 hover:text-yellow-600" data-testid="admin-login-back">
              ← Retour au site
            </a>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
